import { Navigate, useLocation } from 'react-router-dom';

// Anclada al final: solo el segmento `klons` que precede al id. Un `replace('/klons/', …)` sin
// anclar cambiaría el slug de una organización llamada `klons` (`/organization/klons/klons/abc`).
const LEGACY_SEGMENT = /\/klons\/([^/]+)\/?$/;

// Redirección permanente de las URLs antiguas del navegador `.../klons/:id` a `.../connections/:id`
// (marcadores y emails ya enviados, design D2). Conserva query string y hash, y usa `replace`
// para que el botón Atrás no devuelva a la URL antigua y provoque un bucle.
export default function LegacyConnectionPathRedirect() {
  const { pathname, search, hash } = useLocation();
  return <Navigate to={`${pathname.replace(LEGACY_SEGMENT, '/connections/$1')}${search}${hash}`} replace />;
}
